import React, { useId } from "react";
import jawf from "./assets/makhraj-v2/jawf.asset.js";
import throatDeep from "./assets/makhraj-v2/throat-deep.asset.js";
import throatMiddle from "./assets/makhraj-v2/throat-middle.asset.js";
import throatUpper from "./assets/makhraj-v2/throat-upper.asset.js";
import tongueRearQaf from "./assets/makhraj-v2/tongue-rear-qaf.asset.js";
import tongueRearKaf from "./assets/makhraj-v2/tongue-rear-kaf.asset.js";
import tongueMiddle from "./assets/makhraj-v2/tongue-middle.asset.js";
import tongueSide from "./assets/makhraj-v2/tongue-side.asset.js";
import tongueLam from "./assets/makhraj-v2/tongue-lam.asset.js";
import tongueNun from "./assets/makhraj-v2/tongue-nun.asset.js";
import tongueRa from "./assets/makhraj-v2/tongue-ra.asset.js";
import tongueUpperRoots from "./assets/makhraj-v2/tongue-upper-roots.asset.js";
import tongueUpperEdges from "./assets/makhraj-v2/tongue-upper-edges.asset.js";
import tongueLowerIncisors from "./assets/makhraj-v2/tongue-lower-incisors.asset.js";
import lowerLip from "./assets/makhraj-v2/lower-lip.asset.js";
import lips from "./assets/makhraj-v2/lips.asset.js";
import nasal from "./assets/makhraj-v2/nasal.asset.js";
import emphatic from "./assets/makhraj-v2/emphatic.asset.js";

export const MAKHRAJ_ASSETS = Object.freeze({
  jawf, "throat-deep": throatDeep, "throat-middle": throatMiddle, "throat-upper": throatUpper,
  "tongue-rear-qaf": tongueRearQaf, "tongue-rear-kaf": tongueRearKaf, "tongue-middle": tongueMiddle,
  "tongue-side": tongueSide, "tongue-lam": tongueLam, "tongue-nun": tongueNun, "tongue-ra": tongueRa,
  "tongue-upper-roots": tongueUpperRoots, "tongue-upper-edges": tongueUpperEdges,
  "tongue-lower-incisors": tongueLowerIncisors, "lower-lip": lowerLip, lips, nasal,
});
export const MAKHRAJ_POINT_IDS = Object.freeze(Object.keys(MAKHRAJ_ASSETS));

export function MakhrajVisual({ point, letter, letterName, visual, nasal: hasNasal = false, emphatic: hasEmphasis = false, compact = false }) {
  const titleId = useId();
  const descriptionId = useId();
  const image = MAKHRAJ_ASSETS[point] || MAKHRAJ_ASSETS.jawf;
  const accessibleName = letterName || letter;
  return <figure className={`makhraj-diagram makhraj-graphic ${compact ? "compact" : ""}`} data-makhraj-point={point} data-nasal={hasNasal || undefined} data-emphatic={hasEmphasis || undefined}>
    <div className="makhraj-graphic-stage" role="img" aria-labelledby={titleId} aria-describedby={descriptionId}>
      <img src={image} alt="" aria-hidden="true" />
      <span className="makhraj-glyph" lang="ar" dir="rtl">{letter}</span>
      {hasNasal && <span className="makhraj-layer makhraj-layer-nasal"><img src={nasal} alt="" aria-hidden="true" /><b>Résonance nasale</b></span>}
      {hasEmphasis && <span className="makhraj-layer makhraj-layer-emphatic"><img src={emphatic} alt="" aria-hidden="true" /><b>Élévation · emphase</b></span>}
    </div>
    <figcaption id={descriptionId}>
      <b id={titleId}>{`Point de sortie de ${accessibleName}`}</b>
      <span>{visual}</span>
      {(hasNasal || hasEmphasis) && <small>{hasNasal ? "Le point oral reste actif ; la ghunnah résonne séparément dans la cavité nasale." : "Le point de sortie reste inchangé ; l’arrière de la langue s’élève pour donner l’emphase."}</small>}
    </figcaption>
  </figure>;
}
